export default {
  "iso3": "dan",
  "iso2": "da",
  "text": {
    "CURRENT_LANGUAGE": "Dansk",
    "CIP8_TITLE": "888CASINO SPIL",
    "Login": "LOG IND",
    "WITHDRAW": "HÆVE",
    "CASHIER": "KASSE",
    "Search": "Søg efter dit spil...",
    "REWARDS": "Rewards",
    "HOME": "Start",
    "888_COM": "888.com",
    "888_POKER": "poker",
    "888_CASINO": "casino",
    "888_BINGO": "bingo",
    "888_SPORT": "sport",
    "SIGN_UP": "TILMELD DIG",
    "DEPOSIT_SIDE_MENU": "Indbetal",
    "MY_ACCOUNT": "MIN KONTO",
    "BALANCE": "Din saldo",
    "MINI_ORBIT_BALANCE": "Saldo:",
    "LOGOUT": "Log ud",
    "GREETING_MORNING": "Godmorgen",
    "GREETING_AFTERNOON": "Goddag",
    "GREETING_EVENING": "Godaften",
    "GREETING_NIGHT": "Godnat",
    "GREETING_DEFAULT": "Hej",
    "MRS_TITLE": "Fru",
    "MR_TITLE": "Hr",
    "SLOTS": "Spilleautomater",
    "LOBBY": 'Lobby',
    "SLOTS_JACKPOTS": "Jackpots & Automater",
    "CARD_TABLE_GAMES": "Kort- og bordspil",
    "CASINO_GAMES": "Casinospil",
    "LIVE_CASINO": "Live Casino",
    "PROMOTIONS": "Kampagner",
    "888SPORT": "888sport",
    "VIP_CLUB": "VIP Club",
    "PWA_INSTALL": "Installér app'en",
    "PWA_ADD_TO_HOME_SCREEN": "Tilføj startskærm",
    "BLOG": "Blog",
    "TODAY_WINNERS": "Dagens vindere",
    "SUPPORT_ID_MESSAGE": "Support-id",
    "DEPOSIT": "INDBETAL",
    "CHOOSE_LANG": "Vælg dit sprog:",
    "CHOOSE_COUNTRY": "Vælg dit land:",
    "SIGN_IN_PLAY": "LOG IND og SPIL",
    "NEW": "Ny",
    "JACKPOT": "Jackpot",
    "EXCLUSIVE": "888 Eksklusive",
    "1-25_LINES": "1-25 rækker",
    "25+_LINES": "25+ rækker",
    "888_EXCLUSIVE_GAMES":"888 Eksklusive spil",
    "INFO_TITLE_ARENA_888_EXCLUSIVE_GAMES":"Eksklusive Casinospil!",
    "INFO_TEXT_ARENA_888_EXCLUSIVE_GAMES":"888casino er stedet, hvor du finder et eksklusivt udvalg af online casinospil. Spil de hotteste online spilleautomater fra Section8 og nyd vores fantastiske casinospil såsom online roulette, online blackjack og video poker. Vores eksklusive casinospil tilbyder også Baccarat, Keno og spil med straks-gevinster. Gør klar til en masse sjov i vores casino-univers!",
    "INFO_TITLE_ARENA_SLOTS": "Online spilleautomater",
    "INFO_TEXT_ARENA_SLOTS": "Vælg mellem mere end 100 spilleautomater af bedste kvalitet, når du spiller online. Oplev en bred vifte af funktioner som bonusspil, ekspanderende wilds, ekstra spin og store jackpotter. Vil du erobre skatten i det gamle Ægypten, søge efter Leprechaun's krukke med guld, eller foretrækker du at holde det helt klassisk? Uanset hvilket tema du er til, så skal du nok finde dit favoritspil!",
    "INFO_TITLE_ARENA_CASINO": "Casinospil",
    "INFO_TEXT_ARENA_CASINO": "Kortene er blandet, hjulet drejer og din plads venter på dig. Spil kun de allerbedste kort- og bordspil online. Vælg mellem en række roulette-spil, herunder Europæisk, Amerikansk, Low, High og Super indsatser. Foretrækker du Blackjack? Spil flere hænder samtidigt. Sørg for at finde din pokerpræference fra Texas Hold’em til Caribbean!",
    "INFO_TITLE_ARENA_ROULETTE": "Roulette Online",
    "INFO_TEXT_ARENA_ROULETTE": "Prøv at ramme dine heldige numre på en af 888casinos førsteklasses online rouletteborde. Vælg mellem vores store udvalg af de bedste rouletteborde, herunder europæisk, amerikansk og fransk roulette. Uanset om du er High Roller eller foretrækker lave indsatser, har vi et roulettebord til dig. Der er intet som spændingen på at vente på, hvor kuglen lander, når du spiller roulette!",
    "INFO_TITLE_ARENA_NEW_GAMES": "Nye Spil",
    "INFO_TEXT_ARENA_NEW_GAMES": " ",
    "INFO_TITLE_ARENA_BLACKJACK": "Blackjack Online",
    "INFO_TEXT_ARENA_BLACKJACK": "Kortene er blandet, og din plads venter på nogle af de bedste online blackjack-spil, du vil spille! Spil blackjack på 888casino på dine egne vilkår med Super Stakes, Side Bets og mere. Er en hånd i blackjack ikke nok for dig? Spil vores Multihand Blackjack-spil, og få tre chancer for at ramme 21, samtidigt!",
    "INFO_TITLE_ARENA_VIDEO_POKER": "Videopoker online",
    "INFO_TEXT_ARENA_VIDEO_POKER": "Hvis du mener, at du er ægte professionel pokerspiller, så er du kommet til det rigtige kasino! Prøv ar ramme den sjældne Royal Flush i vores forskellige videopokerspil. Hvis du mere er til 5-card draw eller foretrækker den altid populære Texas Hold’em, kan du finde din nye favorit online videopokerspil på 888casino.",
    "INFO_TITLE_ARENA_SCRATCH_CARDS": "Skrabelodder online",
    "INFO_TEXT_ARENA_SCRATCH_CARDS": "Der er intet som en hurtig gevinst i et af 888casinos spændende skrabelodspil. Ideel til sjov uden strategi. Vælg et online skrabelod i dit temavalg. Afslør dine irske rigdomme, eller opdag faraos formue. Det er dit valg. Du skal blot vælge det beløb, du vil bette, og se, om du vinder på dit skrabelod!",
    "NETENT_SLOTS": "NETENT SPILLEAUTOMATER",
    "BONUS": "Bonus",
    "FREE_SPINS": "Gratis spins",
    "CLEAR_ALL": "Slet alt",
    "FILTER": "Filter",
    "APPLY": "Anvend",
    "ROULETTE": "Roulette",
    "BLACKJACK": "Blackjack",
    "BACCARAT": "Baccarat",
    "POKER": "Poker",
    "KENO": "Keno",
    "HIGH_LIMIT": "High Limit",
    "LANGUAGES": "Sprog",
    "HELP": "Hjælp",
    "LIVE_CHAT": "Live chat",
    "DEMO": "Demo",
    "PLAY": "Spil",
    "NOT_NOW": "Ikke nu",
    "NO_THANKS": "Nej tak",
    "LETS_PLAY": "Lad os spille!",
    "GOT_IT": "GOT IT!",
    "LIMITS": "Grænser",
    "LIVE": "Live",
    "SEE_ALL": "Se alle",
    "WINNING_IN_THE_LAST_30_DAYS": "Gevinster de sidste 30 dage",
    "TOTAL_JACKPOTS": "Jackpots i alt",
    "TOP_GAMES": "BEDSTE SPILLEAUTOMATSPIL",
    "LIVE_CASINO_TABLES": "UDVALGTE LIVE-BORDE",
    "TOP_CASINO_GAMES": "BEDSTE CASINOSPIL",
    "JACKPOTS": "Jackpots",
    "RECENTLY_PLAYED": "Spillet for nylig",
    "MINIMUM_BET": "Min. indsats",
    "MAXIMUM_BET": "Maks. indsats",
    "PAYLINES": "Gevinstrækker",
    "BONUS_GAME": "Bonusspil",
    "MAX_PER_SPOT": "Maks. pr. plads",
    "MULTIPLAYER": "Multiplayer",
    "MULTIHAND": "Multihand",
    "DECKS": "Sæt kort",
    "SIDE_BETS": "Sideindsatser",
    "ABOUT": "Om",
    "GAME_JACKPOT": "Spil Jackpot",
    "SLOT_GAMES": "Spilleatomatspil",
    "CARD_AND_TABLE_GAMES": "Kort- og bordspil",
    "JACKPOT_GAMES": "Jackpot-spil",
    "JACKPOT_CENTRAL": "Alle med Jackpot",
    "OTHER": "Andet",
    "POKER_GAMES": "POKERSPIL",
    "YOUR_SEARCH_DID_NOT_MATCH_ANY_GAMES": "Ingen spil matchede din søgning",
    "PREMIER_ONLINE_LIVE_CASINO": "Premier live-casino",
    "All_SLOTS": "Alle spilleautomater",
    "All_CARD_AND_TABLE_GAMES": "Alle kort- og bordspil",
    "USEFUL_LINKS": "Nyttige links",
    "PRIVACY_POLICY": "Fortrolighedspolitik",
    "USER_AGREEMENT": "Brugeraftale",
    "RESPONSIBLE_GAMBLING": "Ansvarlig spil",
    "SAFE_ZONE": "Control Centre",
    "CONTACT": "Kontakt os",
    "COMP_POINTS": "Bonuspoint",
    "GAMING_HISTORY": "Spilhistorik",
    "MY_CHALLENGES": "Mine udfordringer",
    "SCRATCHCARDS": "SKRABELOD",
    "QUICK_LINKS_TITLE": "HURTIGE LINKS",
    "NO_SEARCH_RESULTS": "Ingen søgeresultater fundet...",
    "SEARCH_YOUR_GAME": "Søg efter spil...",
    "SEARCH_RESULTS_TITLE": "BEDSTE SØGERESULTATER",
    "SUGGESTED_GAMES": "FORESLÅEDE SPIL",
    "SUGGESTED_CATEGORIES": "FORESLÅEDE KATEGORIER",
    "BACK": "Tilbage",
    "HIT_THE_JACKPOT": "Ram jackpotten",
    "OUR_JACKPOTS": "VORES JACKPOTS",
    "MY_CLUB": "Min klub",
    "CASH_BALANCE": "Kontantsaldo",
    "BONUS_BALANCE": "Bonussaldo",
    "YOU_MAY_LIKE": "Du ville synes om",
    "TOP_PICKS_FOR": "BEDSTE VALG TIL {USERNAME}",
    "888CLUB": "888club",
    "888POKER": "888poker",
    "BACK_TO_888POKER": "Tilbage til 888poker",
    "BACK_TO_888SPORT": "Tilbage til 888sport",
    "VIDEO_POKER_GAMES": "Videopokerspil",
    "VIDEO_POKER": "Videopoker",
    "SEO_IMAGE_CATEGORIES_TITLE": "Bedste {categoryName} oplevelse på 888casino",
    "SEO_IMAGE_CATEGORIES_ALT": "online casino - {categoryName}",
    "SEO_IMAGE_GAME_TITLE": "{gameName} {categoryName}",
    "LOW_ROLLERS": "Low Rollers",
    "TOP_NETENT_SLOTS": "TOP NETENT AUTOMATER",
    "PLAY_50_FREESPINS": "SPIL 30 NETENT REALSPIN",
    "HOLIDAY_GAMES": "SPIL I FERIEN",
    "ELITE_LOUNGE": "Elite-Lounge",
    "ORIGINALS": "888 Originaler",
    "RELATED_GAMES": "FORDI DU VALGTE: {gameName}",
    "DAILY_JACKPOT_GAMES": "Daglige jackpotspil",
    "LOW_STAKES": "Low Stakes",
    "CLASSIC_SLOTS": "Klassiske spilleautomater",
    "ALL_JACKPOTS": "ALLE JACKPOTS",
    "POPULAR_GAMES_TITLE": "Populære spil",
    "MORE": "Flere",
    "HOMEPAGE-SPOOKY_SPINS": "Spooky Spins",
    "THE_DAILY_JACKPOT": "888 DAGLIG JACKPOT",
    "HIGH_NOON_JACKPOT": "Middagstid-jackpot",
    "TWILIGHT_JACKPOT": "Tusmørke-jackpot",
    "RED_TIGER_DAILY_JACKPOT": "RED TIGER'S DAGLIGE JACKPOT",
    "PROGRESSIVE_JACKPOTS": "PROGRESSIVE JACKPOTTER",
    "INFO_TITLE_ARENA_JACKPOTS": "Jackpotter",
    "INFO_TEXT_ARENA_JACKPOTS": "Jackpot-spil kan give dig en særlig stor fortjeneste. Nogle jackpot-spil har ikke kun én progressiv jackpot, men to eller tre, som du kan vinde allesammen. Hos 888casino kan du spille mange jackpot-spil med forskellige design. Prøv lykken på en jackpot-spilleautomat og rejs tilbage til det gamle Ægypten, bevæg dig ind i den eventyrlig irske mytologi eller i rædselsverdenen på Elm Street. Det er mega-sjovt at spille på jackpot-maskinerne, og du kan blive mega-rig!",
    "INSTANT_GAMES": "Vind Spil Øjeblikkeligt",
    "INSTANT_WIN_GAMES_ARENA": "Vind Spil Øjeblikkeligt",
    "ALL_INSTANT_WIN_GAMES": "ALLE VIND SPIL ØJEBLIKKELIGT",
    "INFO_TITLE_ARENA_INSTANT_WIN_GAMES": "Vind Spil Øjeblikkeligt",
    "INFO_TEXT_ARENA_INSTANT_WIN_GAMES": "Straks-spil giver det hele på et øjeblik – det er sjov på sekundet. Gør dig klar til at spille de bedste skrabe-spil, som findes på kloden. Du kan boltre dig i spil som Volcano Eruption, Panda Mania og Merlin’s Millions. Er tiden knap men skal der alligevel ske noget sjovt? Bare rolig – prøv vores keno eller bingo-spil eller de sprudlende, hotte spil som Chicken Extreme, 7-UP og Epic Gems. Det er den helt store fest, og det bedste er, at du er inviteret! Det er uhyggelig let at spille straks-spil. Her behøver du ingen forudsætninger – det er bare; vælg, klik og vind!",
    "TRENDING_SLOTS": "DE NYESTE SPILLEAUTOMATER",
    "EXCLUSIVE_LIVE_TABLES": "EKSKLUSIVE LIVE-BORDE",
    "BLACKJACK_AND_ROULETTE_GAMES": "BLACKJACK- OG ROULETTESPIL",
    "ALL_888_EXCLUSIVE_GAMES": "ALLE 888 EKSKLUSIVE SPIL",
    "LIVE_ARENA_TABLE_IS_CLOSED_MESSAGE": "Bordet åbner kl.",
    "LIVE_CASINO_TABLE_FULL_PC": "Bordet er fuldt",
    "LIVE_CASINO_TABLE_FULL_MOBILE": "Fuldt",
    "GAME_SHOWS": "Spillet viser",
    "TOP_EVO_GAMES": "Topspil",
    "VIRTUAL_SPORTS": "Virtuelt Sport",
    "LETS_PLAY_MONOPOLY": "Lad os spille Monopoly",
    "TOP_TRENDING_SLOTS": "Mest populære spilleautomater",
    "TOP_PAYING_SLOTS": "Spilleautomater med størst udbetaling",
    "RECENTLY_ADDED": "Tilføjet for nyligt",
    "TOP_SLOTS": "Bedste spilleautomater",
    "INFO_TITLE_ARENA_VIRTUAL_SPORTS": "Virtuelt Sport",
    "INFO_TEXT_ARENA_VIRTUAL_SPORTS": "Virtuelt Sport bringer dig en bred variant af computer-genererede sportskampe som du kan spille på døgnet rundt. Så hvorfor vente på den store kamp i aften, når du kan spille på vores virtuelle lige nu?",
    "REAL_MONEY_GAME": "Dette spil kan kun spilles med din kontantsaldo.",
    "NEW_GAMES": "Nye spil",
    "TOP_EXCLUSIVE_SLOTS": "Top Exclusive Slots",
    "TOP_10_IN_YOUR_COUNTRY": "Top 10 in your country",
    "CANT_CONNECT_ERROR_TITLE": "Kan ikke oprette forbindelse",
    "CANT_CONNECT_ERROR_MESSAGE": "Beklager, vi havde et teknisk uheld.",
    "RETRY": "PRØV IGEN",
    "TRANSACTION_HISTORY": "Transaktionshistorik",
    "REVERSE_WITHDRAWAL": "Annullering af udbetaling",
    "UPLOAD_DOCUMENTS": "Upload dokumenter",
    "HOTTEST_NEW_GAMES": "Mest populære nye spil",
    "BRAND_NEW": "Splinternye",
    "SINCE_LAST_MONTH": "Siden sidste måned",

    // game popup
    "GAME_POPUP_GAME_UNAVAILABLE" : "Beklager, dette spil er ikke tilgængeligt",
    "GAME_POPUP_MAY_LIKE" : "Du kan måske også lide:",

    // party jackpot
    "PARTY_JACKPOT_WELCOME_POPUP_TITLE": "HURRA! Du skal til at spille et {partyJackpotName}-spil!",
    "PARTY_JACKPOT_WELCOME_POPUP_TITLE_ALL_LIVE_CASINO": "LUCKY YOU!",
    "PARTY_JACKPOT_WELCOME_POPUP_SUB_TITLE_ALL_LIVE_CASINO": "All Live Casino games are part of our HOT NEW jackpot!",

    "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION": "Jackpotten kan vindes på enhver cash saldoindsats.\n Alle Party Jackpot-præmier er bonusser, som øjeblikkeligt krediteres til din konto.",
    "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION_REAL": "Enhver indsats med rigtige penge på et Party Jackpot-spil kan vinde en kontantpræmie!\nParty Jackpot udbetaler dagligt!",
    "PARTY_JACKPOT_WELCOME_POPUP_BOTTOM_NOTE": "Bonus: omsætningskrav 30x (varierer efter spiltype), udløber efter 90 dage, gevinster begrænses til 500 $, gælder for udvalgte spil",
    "PARTY_JACKPOT_WELCOME_POPUP_BOTTOM_NOTE_REAL": "Kun for spillere, der har indbetalt",
    "PARTY_JACKPOT_WELCOME_POPUP_TERMS_AND_CONDITIONS_APPLY": "Vilkår og betingelser gælder.",

    "PARTY_JACKPOT_WIN_TOASTER_TITLE": "{jackpotName} på {winAmount} er lige blevet vundet!",
    "PARTY_JACKPOT_WIN_TOASTER_SUBTITLE": "Vandt du ikke? Ingen grund til at ærgre dig!\n Denne jackpot kan vindes hver time, {startHour}-{endHour}.",
    "PARTY_JACKPOT_WIN_POPUP_YOU_WON": "DU VANDT {jackpotName}",
    "PARTY_JACKPOT_WIN_POPUP_AWESOME": "FANTASTISK!",
    "PARTY_JACKPOT_OUT_OF_CASH_TOASTER_TITLE": "Tilføj midler for at spille Live Casino Jackpot",
    "PARTY_JACKPOT_OUT_OF_CASH_TOASTER_SUBTITLE": " Live Casino Jackpot kan kun vindes med pengespil",

    // jackpot widget
    "JACKPOT-WIDGET-MUST-PAY": "Skal betale inden:",
    "JACKPOT-WIDGET-DROPS-SOON": "FALDER SNART!",
    "JACKPOT-WIDGET-STARTS-SOON": "BEGYNDER SNART",
    "JACKPOT-WIDGET-NEXT-JACKPOT": "Start af næste jackpot",
    "JACKPOT-WIDGET-LAST-WIN": "Sidste gevinst",
    "IN-GAME-WIDGET-STARTS-SOON": "Begynder snart",

    "FREEPLAY_INDICATOR": "Ekstraspil",
    "OMG_INDICATOR": "Beskeder",

    "USER_LIKE_YOU": "TOP {topNumber} I {countryName}",
    "YOUR_COUNTRY": "Dit land",
    "CLOSE": "Luk",

    //video live stream
    "LIVE_STREAM_WATCH_TIME_REACHED": "Klar til at kaste dig ud I at spille?",
    "LIVE_STREAM_VIDEO_LOADING": "Indlæser...",
    "PLAY_NOW": "SPIL",
    "CASINO": "CASINO",

    // Payments Redirect Focus
    "PAYMENTS_REDIRECT_FOCUS_TITLE": "Kan du ikke se vinduet?",
    "PAYMENTS_REDIRECT_FOCUS_TEXT": "Klik på Fortsæt for at bringe det tilbage.",
    "PAYMENTS_REDIRECT_FOCUS_CTA": "Fortsæt",

    //Admin Lists Volatile
    "VOLATILE_SLOTS": "Volatile spilleautomater",
    "VOLATILE_GAMES": "Volatile spil",
    "HIGH_VOLATILITY_SLOTS": "Spilleautomater med høj volatilitet",
    "LOW_VOLATILITY_SLOTS": "Spilleautomater med lav volatilitets"
  }
}
